// Catálogo de Care Gap Status (grupo `care_gaps`)
export const CARE_GAP_STATUS = {
  OPEN:      { id: 53, key: "open",      name: "Open" },
  SUBMITTED: { id: 54, key: "submitted", name: "Submitted" },
  CLOSED:    { id: 55, key: "closed",    name: "Closed" },
};

export const CARE_GAP_STATUS_OPTIONS = [
  { id: 53, key: "open",      name: "Open" },
  { id: 54, key: "submitted", name: "Submitted" },
  { id: 55, key: "closed",    name: "Closed" },
];

// Workflow Status (grupo `care_gap_workflow`). IDs reales del backend (56..86).
// Los más usados — los demás se manejan por ID y nombre que llega del API.
export const WORKFLOW_STATUS = {
  NEW:              { id: 56, key: "new",              name: "New - Not reviewed" },
  PENDING:          { id: 57, key: "pending",          name: "Pending review" },
  IN_PROGRESS:      { id: 58, key: "in_progress",      name: "In progress" },
  CONTACT_ATTEMPT:  { id: 59, key: "contact_attempt",  name: "Contact attempted" },
  NO_PHONE:         { id: 60, key: "no_phone",         name: "No phone number" },
  VOICEMAIL:        { id: 61, key: "voicemail",        name: "Voicemail" },
  CONTACTED:        { id: 62, key: "contacted",        name: "Contacted" },
  REFUSED:          { id: 63, key: "refused",          name: "Patient refused" },
  LANGUAGE_BARRIER: { id: 64, key: "language_barrier", name: "Language barrier" },
  SCHEDULED:        { id: 65, key: "scheduled",        name: "Scheduled" },
  CLOSED_AVAILITY:  { id: 72, key: "closed_availity",  name: "Closed on Availity" },
  DECEASED:         { id: 85, key: "deceased",         name: "Deceased" },
  OTHER:            { id: 86, key: "other",            name: "Other" },
};

// Lista completa para el dropdown "More". Cualquier nombre/ID que retorne el
// API y no esté aquí simplemente se muestra como vino del backend.
export const WORKFLOW_STATUS_OPTIONS = [
  { id: 56, name: "New - Not reviewed" },
  { id: 57, name: "Pending review" },
  { id: 58, name: "In progress" },
  { id: 59, name: "Contact attempted" },
  { id: 60, name: "No phone number" },
  { id: 61, name: "Voicemail" },
  { id: 62, name: "Contacted" },
  { id: 63, name: "Patient refused" },
  { id: 64, name: "Language barrier" },
  { id: 65, name: "Scheduled" },
  { id: 72, name: "Closed on Availity" },
  { id: 85, name: "Deceased" },
  { id: 86, name: "Other" },
];

// Canales de outreach permitidos (validación en el modal)
export const OUTREACH_CHANNELS = ["Phone", "Text", "Email", "In person"];

export const OUTREACH_RESULTS = [
  "Contacted",
  "Voicemail",
  "No answer",
  "Wrong number",
  "Disconnected",
  "Refused",
  "Other",
];

export const OUTREACH_NEXT_ACTIONS = [
  "Schedule appointment",
  "Call back later",
  "Send text reminder",
  "Send email",
  "No further action",
  "Other",
];

// Colores asociados al status (chip + borde de la card)
export const CARE_GAP_STATUS_COLORS = {
  open:      { bg: "#ffebee", border: "#e53935", text: "#c62828",   chip: "error"   },
  submitted: { bg: "#fff8e1", border: "#fb8c00", text: "#e65100",   chip: "warning" },
  closed:    { bg: "#e8f5e9", border: "#43a047", text: "#2e7d32",   chip: "success" },
};

// Colores por workflow más usado (los no listados → gris)
export const WORKFLOW_STATUS_COLORS = {
  new:              "#ef5350",
  pending:          "#ff9800",
  in_progress:      "#fb8c00",
  contact_attempt:  "#fdd835",
  contacted:        "#fdd835",
  voicemail:        "#fdd835",
  scheduled:        "#1e88e5",
  closed_availity:  "#43a047",
  refused:          "#9e9e9e",
  no_phone:         "#9e9e9e",
  language_barrier: "#9e9e9e",
  deceased:         "#757575",
  other:            "#9e9e9e",
};
